import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Authority {
  name: string;
  emailId: string;
  phoneNumber: string;
}

export interface AgencyOnboardingState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

export const ownerDetailsSliceState: AgencyOnboardingState = {
  loading: false,
  error: null,
  success: false,
};

const ownerDetailsSlice = createSlice({
  name: 'ownerDetails',
  initialState: ownerDetailsSliceState,
  reducers: {
    submitOwnerDetailsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },

    submitOwnerDetailsSuccess: (state) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },

    submitOwnerDetailsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    setSuccess: (state, action: PayloadAction<any | null>) => {
      state.success = action.payload;
    },
  },
});

export const {
  submitOwnerDetailsRequest,
  submitOwnerDetailsSuccess,
  submitOwnerDetailsFailure,
  setSuccess,
} = ownerDetailsSlice.actions;

export default ownerDetailsSlice.reducer;
